<template>
  <div class="v2-staff-picks">
    <div class="section-header mb-3 mb-md-4 row">
      <h2 class="mb-3 mb-lg-0 col-12 col-lg-6">
        {{ t("Ersties Picks") }}
      </h2>
      <span
        class="col-12 col-lg-6"
        v-html="
          t(
            'While <b>we absolutely adore all the films we make here at Ersties</b>, there are always some that stick out. We all have our favorites, and in each of our staff picks, one of us will share the inside scoop, previously untold stories, and all the other things that made this production extra memorable to us.',
          )
        "
      />
    </div>
    <app-carousel
      :breakpoints="{
        576: {
          itemsToShow: 2,
        },
        768: {
          itemsToShow: 2,
        },
        992: {
          itemsToShow: 3,
        },
      }"
      theme="light"
      @page-change="pageChange"
    >
      <slide v-for="video in videos" :key="video.id">
        <video-item :video="video" :playable="true" theme="light" :show-rating="false" />
      </slide>
    </app-carousel>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import FreeareaService from "@/api/services/freeareaService";
import { Slide } from "vue3-carousel";
import AppCarousel from "@/components/v2/app-carousel/index.vue";
import VideoItem from "@/components/v2/video-item/index.vue";
import { amplitudeCarouselTrack } from "@/utils/amplitude";
import { Video } from "@/interfaces/Video/Video.ts";
import { useI18n } from "vue-i18n";

defineOptions({
  name: "staff-picks",
});

const { t } = useI18n();

const videos = ref<Video[]>([]);

const pageChange = () => {
  amplitudeCarouselTrack("Staff picks slider");
};

onMounted(async () => {
  videos.value = await FreeareaService.getStaffPicks();
});
</script>

<style lang="scss">
@import "./index.scss";
</style>
